module.exports = __webpack_public_path__ + "img/cloud-server.f858bf38.svg";